import {axiosAuth, axiosUsers} from "../../helpers/axios_requests";
import constants from "../../helpers/constants";
import ROUTER, {ROUTES_NAMES} from "../../router";

const STORAGE_KEY_TOKEN = 'token'

export default {
  actions: {
    actionInitUser: async (context) => {
      await axiosAuth.get()
        .then(r => {
          context.dispatch('actionSetUser', r.data || null)
        })
        .catch(e => {
          console.log(e);
        })
        .finally(() => {
          context.dispatch('actionSetUserLoaded', true)
        })
    },
    actionInitUserRoles: async (context) => {
      if (context.getters.getUserRolesLoaded || context.getters.getUserRolesLoading) return
      context.dispatch('actionSetUserRolesLoading', true)
      await axiosUsers.roles()
        .then(r => {
          let index = 1
          context.dispatch(
            'actionSetUserRoles',
            Object.entries(r.data).map(([key, value]) => {
              return {
                id: index++ ,
                key: key,
                value: value
              }
            })
          )
        })
        .finally(() => {
          context.dispatch('actionSetUserRolesLoading', false)
          context.dispatch('actionSetUserRolesLoaded', true)
        })
    },
    actionSetUserToken: (context, str = null) => {
      if (str) {
        localStorage.setItem(STORAGE_KEY_TOKEN, str)
      } else {
        localStorage.removeItem(STORAGE_KEY_TOKEN)
      }
      context.commit('mutationSetUserToken', str)
    },
    actionLogoutUser(context, query = null) {
      context.dispatch('actionSetUser')
      context.dispatch('actionSetUserToken')
      let route_params = {
        name: ROUTES_NAMES.login,
      }
      if (query) {
        route_params['query'] = query
      }
      ROUTER.push(route_params)
    },

    actionSetUser: (context, user = null) => context.commit('mutationUser', user),
    actionSetAdminImpersonateUser: (context, user = null) => context.commit('mutationSetAdminImpersonateUser', user),
    actionSetUserLoaded: (context, user = null) => context.commit('mutationSetUserLoaded', user),
    actionSetUserRoles: (context, list = []) => context.commit('mutationSetUserRoles', list),
    actionSetUserDailyStatus: (context, value = false) => context.commit('mutationSetUserDailyStatus', value),
    actionSetUserRolesLoading: (context, bool = false) => context.commit('mutationSetUserRolesLoading', bool),
    actionSetUserRolesLoaded: (context, bool = false) => context.commit('mutationSetUserRolesLoaded', bool),
  },
  mutations: {
    mutationUser: (state, user) => state.user = user,
    mutationSetAdminImpersonateUser: (state, user) => state.userAdmin = user,
    mutationSetUserLoaded: (state, bool) => state.user_loaded = bool,
    mutationSetUserToken: (state, str) => state.user_token = str,
    mutationSetUserRoles: (state, list) => state.user_roles = list,
    mutationSetUserDailyStatus: (state, value) => state.user_has_today_report = value,
    mutationSetUserRolesLoading: (state, bool) => state.user_roles_loading = bool,
    mutationSetUserRolesLoaded: (state, bool) => state.user_roles_loaded = bool,
  },
  state: {
    user_loading: false,
    user_loaded: false,
    user: null,
    userAdmin: null,
    user_token: localStorage.getItem(STORAGE_KEY_TOKEN) ?? null,
    user_roles: [],
    user_has_today_report: false,
    user_roles_loading: false,
    user_roles_loaded: false,
  },
  getters: {
    getUser: state => state.user,
    getAdminImpersonateUser: state => state.userAdmin,
    getUserMailVerified: state => Boolean(state.user?.email_verified_at),
    getUserLoaded: state => state.user_loaded,
    getUserToken: state => state.user_token,
    getUserRoles: state => state.user_roles,
    getUserRolesLoading: state => state.user_roles_loading,
    getUserRolesLoaded: state => state.user_roles_loaded,
    getUserRoleName: state => state.user?.role || '',
    getUserRole: (state) => (role) => state.user_roles.find(el => el.key === role)?.value || '',
    getUserRoleIsAdmin: (state, getters) => getters.getUser?.role?.slug === constants.user.admin_role || false,
    getUserRoleIsNewUser: (state, getters) => getters.getUser?.role?.slug === constants.user.new_user || false,
    getUserIsManager: state => (state.user?.manager_committees || []).length,
    getUserHasDailyReport: state => (state.user_has_today_report)
  }
}
